<div class="edit-row-tab">
    <!-- Header with view toggle -->
    <div class="edit-row-header">
        <div class="header-left">
            <h3 class="tab-title">
                <i class="material-icons">edit</i>
                Edit Row
                <span class="entity-name" *ngIf="selectedEntity"> - {{ selectedEntity.entityName }} </span>
            </h3>
        </div>
        <div class="header-right">
            <div class="view-toggle-group">
                <button class="view-btn" [class.active]="!isCompactView" [class.inactive]="isCompactView" (click)="setNormalView()" title="Normal View">
                    <i class="material-icons">view_agenda</i>
                    <span>Normal</span>
                </button>
                <button class="view-btn" [class.active]="isCompactView" [class.inactive]="!isCompactView" (click)="setCompactView()" title="Compact View">
                    <i class="material-icons">view_compact</i>
                    <span>Compact</span>
                </button>
            </div>
            <button *ngIf="rowData && selectedEntity" class="btn btn-cancel" (click)="cancel()" [disabled]="isSaving">
                <i class="material-icons">close</i>
                Cancel
            </button>
            <button *ngIf="rowData && selectedEntity" class="btn btn-save" (click)="save()" [disabled]="!hasChanges || isSaving">
                <i class="material-icons">{{ isSaving ? 'hourglass_empty' : 'save' }}</i>
                {{ isSaving ? 'Saving...' : 'Save' }}
            </button>
        </div>
    </div>

    <!-- Content Area -->
    <div class="edit-row-content" [ngClass]="{ 'compact-view': isCompactView, 'normal-view': !isCompactView }">
        <!-- No Row Selected Message -->
        <div *ngIf="!rowData || !selectedEntity" class="no-row-message">
            <div class="message-content">
                <i class="material-icons">info</i>
                <p>Select a row from the master grid to edit</p>
                <p class="hint">Right-click on a row and select "Update current row" to open it here</p>
            </div>
        </div>

        <!-- Edit Form -->
        <div *ngIf="rowData && selectedEntity" class="edit-form-container">
            <form class="edit-form" [ngClass]="{ compact: isCompactView, normal: !isCompactView }">
                <div class="form-fields" [ngClass]="{ 'compact-layout': isCompactView, 'normal-layout': !isCompactView }">
                    <!-- Read-only Fields (from metadata readOnly property) -->
                    <div *ngFor="let property of getReadOnlyProperties()" class="form-field" [ngClass]="{ 'compact-field': isCompactView, 'normal-field': !isCompactView }">
                        <label class="field-label">
                            <i class="material-icons" *ngIf="isIdField(property.name)">key</i>
                            {{ getDisplayName(property.name) }}{{ isIdField(property.name) ? ' (ID)' : '' }}
                        </label>
                        <input type="text" class="field-input readonly" [value]="rowData[property.name] ?? ''" readonly disabled />
                    </div>

                    <!-- Editable Fields (readOnly: false from metadata) -->
                    <div *ngFor="let property of getEditableProperties()" class="form-field" [ngClass]="{ 'compact-field': isCompactView, 'normal-field': !isCompactView }">
                        <label class="field-label">
                            {{ getDisplayName(property.name) }}
                        </label>
                        <!-- Text Input -->
                        <input
                            *ngIf="!isDateType(property.type) && !isBooleanType(property.type) && !isNumberType(property.type)"
                            type="text"
                            class="field-input"
                            [value]="editedData[property.name] || ''"
                            (input)="onFieldChange(property.name, $any($event.target).value)"
                            [placeholder]="'Enter ' + property.name"
                        />
                        <!-- Number Input -->
                        <input
                            *ngIf="isNumberType(property.type)"
                            type="number"
                            class="field-input"
                            [value]="editedData[property.name] || ''"
                            (input)="onFieldChange(property.name, $any($event.target).value)"
                            [placeholder]="'Enter ' + property.name"
                        />
                        <!-- Date Input -->
                        <input
                            *ngIf="isDateType(property.type)"
                            type="datetime-local"
                            class="field-input"
                            [value]="formatDateForInput(editedData[property.name])"
                            (input)="onFieldChange(property.name, $any($event.target).value)"
                            [placeholder]="'Enter ' + property.name"
                        />
                        <!-- Boolean Checkbox -->
                        <div *ngIf="isBooleanType(property.type)" class="checkbox-container">
                            <input
                                type="checkbox"
                                class="field-checkbox"
                                [checked]="editedData[property.name] === true || editedData[property.name] === 'true'"
                                (change)="onFieldChange(property.name, $any($event.target).checked)"
                                [id]="'checkbox-' + property.name"
                            />
                            <label [for]="'checkbox-' + property.name" class="checkbox-label">
                                {{ editedData[property.name] === true || editedData[property.name] === 'true' ? 'Yes' : 'No' }}
                            </label>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
